<template>
  <SiteMenuFlyoutLayout :heading="heading" @close="$emit('close')">
    <div class="space-y-4">
      <div
        class="bg-white rounded-lg p-7"
        :style="{ backgroundColor: itemsBackgroundColour }"
      >
        <ul class="text-sm space-y-10">
          <li v-for="(item, itemKey) in items" :key="itemKey">
            <a
              class="flex justify-between items-baseline"
              :href="item.link.url"
            >
              <div class="flex-shrink w-60">
                <h4 class="uppercase font-semibold tracking-widest">
                  {{ item.link.text }}
                </h4>
                <p v-if="item.description" class="mt-3">
                  {{ item.description }}
                </p>
              </div>

              <div class="flex-shrink-0 w-3 h-3"><IconArrowRightShort /></div>
            </a>
          </li>
        </ul>
      </div>

      <div
        v-if="cta"
        class="bg-white rounded-lg p-7 relative z-10 overflow-hidden"
        :style="{
          backgroundColor: cta.backgroundColour,
          color: cta.textColour,
        }"
      >
        <div class="w-60 max-w-full space-y-5">
          <h4 class="text-lg font-semibold">
            {{ cta.heading }}
          </h4>
          <a
            class="btn-soft"
            :class="{
              'btn-soft--alt': cta.textColour === 'white',
            }"
            :href="cta.button.url"
            :target="cta.button.target"
          >
            {{ cta.button.text }}
          </a>
        </div>
      </div>
    </div>
  </SiteMenuFlyoutLayout>
</template>

<script>
import SiteMenuFlyoutLayout from "./SiteMenuFlyoutLayout.vue";
import IconArrowRightShort from "../../../templates/_includes/svg/icon-arrow-right-short.svg";

export default {
  name: "SiteMenuFlyoutMegaPrimarySub",

  components: {
    SiteMenuFlyoutLayout,
    IconArrowRightShort,
  },

  props: {
    heading: {
      type: String,
      default: null,
    },
    itemsBackgroundColour: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      default: null,
    },
    cta: {
      type: Object,
      default: null,
    },
  },
};
</script>
